import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { Observable } from 'rxjs';
import { CreateLessonBookingRequest } from '../classes/CreateLessonBookingRequest';

const httpOptions = {
  headers: new HttpHeaders({ 'Content-Type': 'application/json' }),
};

@Injectable({
  providedIn: 'root'
})
export class BookedLessonsService {
  constructor(private httpClient: HttpClient) {
  }

  public getBookedLessonsByDateRange(
    startDate: string,
    endDate: string,
    page: number,
    size: number,
    filters: string[] = []
  ): Observable<any> {
    const params = [`start=${startDate}&end=${endDate}&page=${page}&size=${size}`, filters.join('&')].join('&');
    return this.httpClient.get<any>(`${environment.backendApiUrl}/v1/lessons-booking/date-range?${params}`, httpOptions);
  }

  public bookLesson(request: CreateLessonBookingRequest): Observable<any> {
    return this.httpClient.post<any>(`${environment.backendApiUrl}/v1/lessons-booking`, request, httpOptions);
  }

  public reScheduleLesson(lessonData: any): Observable<any> {
    return this.httpClient.put(`${environment.backendApiUrl}/v1/lessons-booking/reschedule`, lessonData, httpOptions);
  }

  public cancelLesson(lessonId: number, reason): Observable<any> {
    return this.httpClient.put(`${environment.backendApiUrl}/v1/lessons-booking/${lessonId}/cancel`, reason, httpOptions);
  }
}
